import CommunicationPage from "./CommunicationPage";

export default CommunicationPage;
